module.exports = __webpack_public_path__ + "img/hot.79e9565b.svg";